module.exports = __webpack_public_path__ + "static/media/carousel-cgc-website-03.ce66c90c.png";